import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { TopProgressService } from './top-progress.service';

/**
 * Counts as one top-progress task for as long as it is rendered. Put it in a `@defer` block's
 * `@loading` section so the bar shows while that block's code downloads:
 * `@defer (on immediate) { <x-panel /> } @loading { <stch-top-progress-task /> }`.
 */
@Component({
  selector: 'stch-top-progress-task',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { hidden: '' },
  template: '',
})
export class TopProgressTaskComponent {
  public constructor() {
    inject(DestroyRef).onDestroy(inject(TopProgressService).begin());
  }
}
